import { type PropsWithChildren } from "react";
import { Wrapper } from "./alert.style";

export const Alert = ({ children }: PropsWithChildren) => {
    return <Wrapper>{children}</Wrapper>;
};
